export const environment = {
  production: false,
  apiUrl: 'https://staging.brokins.fr',
  casApiUrl: 'https://staging.brokins.fr/cas-api',
  cacApiUrl: 'https://staging.brokins.fr',
  flaskUrl: 'https://staging.brokins.fr/flask-api',
  apiEndpoint: '/api',
  baseHref: '/',
  enableLogging: true,
  enableDebugTools: true
};
